import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from "js-cookie";

import translationEN from "./locales/en/translation.json";
import translationSV from "./locales/sv/translation.json";

const savedLanguage = localStorage.getItem("language") || Cookies.get("language");

const resources = {
  en: {
    translation: translationEN,
  },
  sv: {
    translation: translationSV,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage || "sv", // default language
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
